import {
    IDynamicService,
    IDynamicServiceConfig,
} from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import {
    ISlideRatingService,
} from '@src/slide/application/service/slide-rating-and-improve/slide-rating-service.interface';
import { SlideRatingService } from '@src/slide/application/service/slide-rating-and-improve/slide-rating-service';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import {
    ISlideContentEnumeratorService,
} from '@src/slide/application/service/slide-content-enumerator/slide-content-enumerator-service.interface';
import {
    ISlideContentLayoutAnalyzerService,
} from '@src/slide/application/service/slide-content-layout-analyzer/core/slide-content-layout-analyzer-service.interface';
import {
    IQuickToolDialogManager,
} from '@src/slide/application/service/quick-tool-dialog-manager/core/quick-tool-dialog-manager.interface';
import { IRightSideBarService } from '@src/slide/application/service/right-side-bar-service/core/interface';
import {
    ISlideContentPreviewService,
} from '@src/slide/application/service/slide-content-preview/core/slide-content-preview.interface';
import {
    IDrawerStateManager,
} from '@src/slide/application/service/drawer-state-manager/core/drawer-state-manager.interface';
import {
    IRightSideBarManager,
} from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';

export const getRatingServiceDynamicConfig = (
    uiDataService: IUiDataService,
    selectionService: ISelectionService,
    slideContentEnumerator: ISlideContentEnumeratorService,
    contentLayoutAnalyzer: ISlideContentLayoutAnalyzerService,
    quickToolDialogManager: IDynamicService<IQuickToolDialogManager>,
    rightSideBarService: IRightSideBarService,
    slideContentPreviewService: IDynamicService<ISlideContentPreviewService>,
    drawerStateManager: IDynamicService<IDrawerStateManager>,
    rightSideBarManager: IRightSideBarManager,
): IDynamicServiceConfig<ISlideRatingService> => ({
    name: 'rating-service',
    loadType: 'on-demand',
    async module() {
        const { SlideRatingService } = (await import('@src/slide/application/service/slide-rating-and-improve/slide-rating-service'));
        return new SlideRatingService(
            uiDataService,
            selectionService,
            slideContentEnumerator,
            contentLayoutAnalyzer,
            quickToolDialogManager,
            rightSideBarService,
            slideContentPreviewService,
            drawerStateManager,
            rightSideBarManager,
        );
    },
});
